import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/pro-solid-svg-icons';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import SortButtons from '../../../../../components/SortButtons/index';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectFerpaState } from '../../../../../features/authentication/authSlice';
import { ResourceUtils } from '../../../../assignments/components/questionDetailComponents/ResourceUtils';

const SelfStudyTable = ({
  data,
  setData,
  isLoading,
  filters
}) => {
  const [sortId, setSortId] = useState('name');
  const [isAscending, setIsAscending] = useState(true);
  const ferpaEnabled = useSelector(selectFerpaState);

  const handleSort = async (currentSortId) => {
    let sortAsc = true;
    if (currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);
    
    let sortedStudents = ResourceUtils.customSort(data, currentSortId, sortAsc);
    setData(sortedStudents);
    setIsAscending(sortAsc);
  };

  return (
    <table className='table reportTable'>
      {data?.length > 0 && !isLoading ? (
        <>
          <thead className='thead-light align-middle'>
            <tr>
              <th className='fw-medium cursor-pointer text-center' onClick={() => handleSort('name')}>
                Student
                <SortButtons
                  selectedSortId={sortId}
                  elementSortId='name'
                  isAscending={isAscending}
                />
              </th>
              <th className='fw-medium text-center'>Course</th>
              <th className='fw-medium text-center'>Class</th>
              <th className='fw-medium cursor-pointer text-center' onClick={() => handleSort('totalSelfStudy')}>
                Total # of Self Study
                <SortButtons
                  selectedSortId={sortId}
                  elementSortId='totalSelfStudy'
                  isAscending={isAscending}
                />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.studentId}>
                <td className='text-center'>
                  <p className='fw-500'>{ferpaEnabled ? item.name : 'name hidden'}</p>
                </td>
                <td className='text-center'>
                  {item.courses?.length === 1 ? (
                    item.courses[0]?.name
                  ) : (
                    <OverlayTrigger
                      placement='top'
                      overlay={
                        <Tooltip className='custom-tooltip'>
                          {item.courses?.map(c => c.name).join(', ')}
                        </Tooltip>
                      }
                    >
                      <span className='cursor-pointer text-decoration-underline text-castleOrange'>
                        Courses ({item.courses?.length})
                      </span>
                    </OverlayTrigger>
                  )}
                </td>
                <td className='text-center'>
                  {item.classes.length === 1 ? (
                    item.classes[0].name
                  ) : (
                    <OverlayTrigger
                      placement='right'
                      overlay={
                        <Tooltip className='initial-assignment-tooltip'>
                          {item.classes.map(c => c.name).join(', ')}
                        </Tooltip>
                      }
                    >
                      <span className='cursor-pointer text-decoration-underline text-castleOrange'>
                        Classes ({item.classes.length})
                      </span>
                    </OverlayTrigger>
                  )}
                </td>
                <td className='text-center'>{item.totalSelfStudy}</td>
                <td className='text-center'>
                  <NavLink to={`${item.studentId}/sessions`} state={{ filters: filters }}>
                    <OverlayTrigger
                      placement='top'
                      overlay={<Tooltip className='custom-tooltip'>Sessions</Tooltip>}
                    >
                      <button className='action-btn-tile blue'>
                        <FontAwesomeIcon icon={faCalendarDays} />
                      </button>
                    </OverlayTrigger>
                  </NavLink>
                </td>
              </tr>
            ))}
          </tbody>
        </>
      ) : isLoading ? (
        <TableSkeleton colCount={5} rowCount={6} />
      ) : (
        <p className='text-danger'>No Self Study Record Found.</p>
      )}
    </table>
  );
};

SelfStudyTable.propTypes = {
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired
};

export default SelfStudyTable;